import React, { useState } from 'react';

export const Login = ({ onLogin }) => {
  const [credentials, setCredentials] = useState({
    username: '',
    password: ''
  });
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setCredentials(prev => ({
      ...prev,
      [name]: value
    }));
    // Limpar erro quando usuário começar a digitar
    if (error) setError('');
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setError('');

    // Simular uma pequena delay para melhor UX
    await new Promise(resolve => setTimeout(resolve, 300));

    try {
      const response = await fetch('/api/client-manager/auth/login', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(credentials),
      });

      if (!response.ok) {
        throw new Error(`Falha na autenticação (HTTP ${response.status})`);
      }

      const data = await response.json();

      if (data.success) {
        // Garante que o token fica disponível imediatamente
        if (data.token) {
          localStorage.setItem('authToken', data.token);
        }
        onLogin({ success: true, token: data.token, user: data.user });
      } else {
        setError(data.message || 'Credenciais inválidas');
      }
    } catch (error) {
      setError(error.message || 'Erro de conexão. Tente novamente.');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="login-page-container">
      <div className="login-centered">
        <div className="login-card">
          <div className="logo-container">
            <img
              src="https://customer-assets.emergentagent.com/job_26ffda92-be08-4603-8924-7735023cc582/artifacts/xriyhnb8_Logotipo-UMTS-no-Background_1080x1080.webp"
              alt="UMTS Logo"
              className="login-logo"
            />
          </div>

          <h1 className="login-title">
            ACESSO RESTRITO
          </h1>

          <p className="login-subtitle">
            Área exclusiva para administradores autorizados
          </p>

          <form onSubmit={handleSubmit} className="login-form">
            <div className="form-group">
              <label htmlFor="username" className="form-label">
                USUÁRIO
              </label>
              <input
                type="text"
                id="username"
                name="username"
                value={credentials.username}
                onChange={handleInputChange}
                className="form-input"
                placeholder="Digite o nome de usuário"
                disabled={isLoading}
                autoComplete="username"
              />
            </div>

            <div className="form-group">
              <label htmlFor="password" className="form-label">
                SENHA
              </label>
              <input
                type="password"
                id="password"
                name="password"
                value={credentials.password}
                onChange={handleInputChange}
                className="form-input"
                placeholder="Digite sua senha"
                disabled={isLoading}
                autoComplete="current-password"
              />
            </div>

            {error && (
              <div className="error-message">
                {error}
              </div>
            )}

            <button
              type="submit"
              className="login-button"
              disabled={isLoading}
            >
              {isLoading ? 'VERIFICANDO...' : 'ENTRAR'}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};